/**
 * Form reducer
 * Modify redux-form state here.
 * See: http://redux-form.com/#/api/reducer/plugin
 *
 * @module reducers/Form
 */
import {
  type FormState as ReduxFormState,
  type FormStateMap,
  reducer as formReducer,
} from 'redux-form';

import { LoginActions } from '../constants/Login';
import { UserAccountActions } from '../constants/UserAccount';

export interface FormState extends FormStateMap {
  CreditCardForm: ReduxFormState;
  UserSettings_AccountInfo: ReduxFormState & {
    currentUsername: $TSFixMe;
    currentPassword: $TSFixMe;
    username: $TSFixMe;
    password: $TSFixMe;
    birthYear: $TSFixMe;
    zipCode: $TSFixMe;
    gender: $TSFixMe;
  };
  RegisterForm: ReduxFormState & { gender: $TSFixMe };
  UserSettings_Privacy: ReduxFormState & { profilePrivate: $TSFixMe };
}

export default formReducer.plugin({
  CreditCardForm: (state: FormState['CreditCardForm'], action) => {
    switch (action.type) {
      default:
        return state;
    }
  },

  UserSettings_AccountInfo: (state: FormState['UserSettings_AccountInfo'], action) => {
    switch (action.type) {
      case UserAccountActions.USER_ACCOUNT_CLEAR_PASSWORD_FORM:
        return {
          ...state,
          currentPassword: {},
        };

      case UserAccountActions.SET_GENDER: {
        const { gender } = action.payload;
        return {
          ...state,
          gender: {
            value: gender,
          },
        };
      }

      default:
        return state;
    }
  },

  RegisterForm: (state: FormState['RegisterForm'], action) => {
    switch (action.type) {
      case LoginActions.SET_GENDER: {
        const { gender } = action.payload;
        return {
          ...state,
          gender: {
            value: gender,
          },
        };
      }

      default:
        return state;
    }
  },
});
